import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import SmoothScroll from "@/components/SmoothScroll";
import Cursor from "@/components/Cursor";
import Home from "@/pages/Home";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <a href="#main" className="skip-link">Μετάβαση στο περιεχόμενο</a>
      <SmoothScroll />
      <Cursor />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/epikoinonia" element={<Contact />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
